export const projectMap: {
  [key: string]: {
    name: string;
    logo: string;
    description?: string;
    banner?: string;
  };
} = {
  atlantis: {
    name: "New Atlantis",
    logo: "https://pbs.twimg.com/profile_images/1469447819610132481/HEScnE8a_400x400.jpg",
  },
  foresight: {
    name: "Foresight Institute",
    logo: "https://pbs.twimg.com/profile_images/1516264107468414976/ce0QvEJu_400x400.jpg",
  },
  vita: {
    name: "VitaDAO",
    logo: "https://pbs.twimg.com/profile_images/1463097895696183298/9EYOgc3Y_400x400.jpg",
  },
  lateral: {
    name: "Lateral",
    logo: "/coordination-network-circle-small.png",
  },
  crdntwrk: {
    name: "coordination.network",
    logo: "/coordination-network-circle-small.png",
  },
  labdao: {
    name: "LabDAO",
    logo: "https://pbs.twimg.com/profile_images/1492164455840423940/uSPUItUM_400x400.jpg",
  },
  psydao_ncmskdfoemrhfncfkxclwmyfhsjsk: {
    name: "PsyDAO",
    logo: "https://pbs.twimg.com/profile_images/1547904716570386435/9EKVxeyM_400x400.jpg",
  },
  hairdao_mfjruxnwhagmhkenxjdkegkem: {
    name: "HairDAO",
    logo: "https://pbs.twimg.com/profile_images/1595800340024147968/mKgNadO0_400x400.jpg",
  },
  "zuzalu-ai": { name: "Zuzalu AI", logo: "/zuzalu.png" },
  "zuzalu-ai-1": { name: "Zuzalu AI", logo: "/zuzalu.png" },
  "zuzalu-ai-2": { name: "Zuzalu AI", logo: "/zuzalu.png" },
  "zuzalu-ai-3": { name: "Zuzalu AI", logo: "/zuzalu.png" },
  "zuzalu-ai-4": { name: "Zuzalu AI", logo: "/zuzalu.png" },
  "zuzalu-ai-5": { name: "Zuzalu AI", logo: "/zuzalu.png" },
  "zuzalu-ai-6": { name: "Zuzalu AI", logo: "/zuzalu.png" },
  "effective-drug-development": {
    name: "Effective Drug Development",
    logo: "/drug-development.jpeg",
    description:
      "Speeding up and reducing the cost of drug development while improving clinical trial success rates is a major challenge despite progress in pharmaceutical research.",
  },
  "eth-ncjeiwkcnalsdkweruasdc": {
    name: "Ethereum Roadmap",
    logo: "/eth-logo.png",
    banner: "/eth-overview.png",
    description:
      "Ethereum is already a powerful platform for global coordination, but it is still being improved. An ambitious set of improvements will upgrade Ethereum from its current form into a fully scaled, maximally resilient platform. These upgrades are laid out in the Ethereum roadmap.",
  },
  bioxyz1: { name: "bio.xyz", logo: "/bioxyz-logo.png" },
};
